import Login from './views/Login.vue'
import NotFound from './views/404.vue'
import Home from './views/Home.vue'
import Register from "./views/register"
import ForgetPassword from "./views/forgetPassword"
import ChangePassword from "./views/changePassword"
import doctorRouter from "./router/doctorRouter"
import nurseRouter from "./router/nurseRouter"
import warehouseAdminRouter from "./router/warehouseAdminRouter"
import adminRouter from "./router/superAdminRouter"


export const defaultRoutes = [{
    path: '/register',
    component: Register,
    name: '',
    hidden: true
}, {
    path: '/login',
    component: Login,
    name: '',
    hidden: true
},{
    path: '/forgetPassword',
    component: ForgetPassword,
    name: '',
    hidden: true
},{
    path: '/changePassword',
    component: ChangePassword,
    name: '',
    hidden: true
},  {
    path: '/home',
    component: Home,
    name: '',
    hidden: true,
    beforeEnter: function (to, from, next) {
        if (from.path === "/login") {
            let user = window.sessionStorage.getItem("user");
            if(user){
                user = JSON.parse(user);
                let roleId = user.roleId;
                if(roleId==='0'){
                    next({path: "/users"})
                }else if(roleId==='3'){
                    next({path: "/inbound"})
                }else{
                    next({path: "/overview"})
                }
            }

        } else {
            next();
        }
    }
}, {
    path: '/404',
    component: NotFound,
    name: '',
    hidden: true
}];

export const doctorRoutes = doctorRouter;

export const nurseRoutes = nurseRouter;

export const warehouseAdminRoutes = warehouseAdminRouter;

export const superAdminRouter = adminRouter;

export default defaultRoutes;




// WEBPACK FOOTER //
// ./src/routes.js